var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'基础设置',path:'/shop/plugin/team-manage/conf'},
    {title:'等级设置',path:'/shop/plugin/team-manage/level'},
    {title:'用户管理',path:'/shop/plugin/team-manage/manage'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }